export const SecurityConstants = {
  authorizeEndpoint: "/oauth2/authorization/google",
  tokenKey: "mis-token",
  serviceKey: "serviceId",
  buidKey: "pms-buids",
  roleKey: "pms-role",
  serviceMapKey: "pms-service-map",
  allBuids: "all-buids"
};
